// extracted by mini-css-extract-plugin
export default {"footer":"_footer_footer__gO-q1","footer_detail":"_footer_footer_detail__zH+Qc"};